import React from 'react';
import { DateInput as KendoDateInput } from '@progress/kendo-react-dateinputs';

const DateInput = (props) => {
    const { value, onChange, onClear, style, ...otherProps } = props;

    const handleClear = () => {
        if (onChange) {
            // For Kendo Form Field usage
            onChange({ value: null });
        }
        if (onClear) {
            // Custom clear handler if provided
            onClear();
        }
    };

    return (
        <div className="yaard-date-input" style={{ position: 'relative', display: 'inline-block', width: '100%', ...style }}>
            <KendoDateInput
                { ...otherProps }
                value={ value }
                onChange={ onChange }
            />
            {value && (
                <button
                    type="button"
                    onClick={ handleClear }
                    className="k-button k-button-flat k-button-md k-icon-button"
                    style={{
                        position: 'absolute',
                        right: '8px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 10,
                        minWidth: 'auto',
                        width: '20px',
                        height: '20px',
                        padding: '0',
                        fontSize: '12px'
                    }}
                    title="Clear date"
                    aria-label="Clear date"
                >
                    ✕
                </button>
            )}
        </div>
    );
};

export default DateInput;
